module.exports = __webpack_public_path__ + "img/workplace-integrations.5bfc78fd.svg";